<template>
  <div class="container-fluid">
    <!-- Row 1 -->
    <div class="row padding-15">
      <div
        class="col-lg-3 col-sm-6 lyout-item"
        v-for="(item, index) in data2"
        :key="index"
      >
        <div class="card">
          <div class="card-header" :style="{ background: item.gradient }">
            <i class="material-icons color-ff icon-size">{{ item.icon1 }}</i>
          </div>
          <div class="card-content">
            <h3 class="title">{{ item.currentCount }}</h3>
            <p class="category mb5">{{ item.category }}</p>
          </div>
          <div class="card-actions alignment-left">
            <div class="stats">
              <i
                class="material-icons"
                :style="{ color: item.iconColor }"
                >{{item.icon2}}</i
              >
              <span :style="{ color: item.iconColor }">
                {{ item.dateLabel }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Row 2 -->
    <div class="row padding-15">
      <div
        class="col-lg-4 col-sm-6 lyout-item"
        v-for="(item, index) in cards2"
        :key="index"
      >
        <div class="card">
          <div class="card-header" :style="{ background: item.gradient }">
            <i class="material-icons color-ff icon-size">{{ item.icon }}</i>
          </div>
          <div class="card-content">
            <p class="category">{{ item.category }}</p>
            <h3 class="title">{{ item.currentCount }}</h3>
          </div>
        </div>
      </div>
    </div>
    <!-- Row 3 -->

    <!-- Row 4 -->
    <div class="row padding-15">
      <div class="col-12 lyout-item ">
        <div class="card bord-15">
          <div class="card-header color-2">
            <i class="material-icons color-ff icon-size">language</i>
          </div>
          <div class="card-content2">
            <p class="category2">Province Wise Trainings Conducted</p>
          </div>
          <div class="row">
            <div class="col-lg-6 col-sm-12">
              <table style="width:100%; margin-left: 10px;">
                <thead>
                  <tr>
                    <th class="table-ro">Province</th>
                    <th class="table-ro">Trainings</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in provinceCounts" :key="index">
                    <td class="table-cl">{{item.provinceTitle}}</td>
                    <td class="table-cl">{{item.trainingCount}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-lg-6 col-sm-12" style="text-align: center;">
              <div id="pie-chart"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Row 5 -->
    <div class="row padding-15">
      <div class="col-12 lyout-item ">
        <div class="card bord-15">
          <div class="card-header color-3">
            <i class="material-icons color-ff icon-size">format_align_left</i>
          </div>
          <div class="card-content2">
            <p class="category2">Thematic Area Trainings Conducted</p>
          </div>
          <div id="thematic-chart" class="bord-15 "></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
    data() {
        return {
            role: '',
            dashboardData: {},
            data2: [],
            cards2: [],
            currentYear: '',
            currentMonth: '',
            provinceCounts: [],
            graphData: [],
            thematicWiseCounts: [],

        }
    },
    mounted() {
        let currentUser = JSON.parse(localStorage.getItem("currentUser"));
        this.role = currentUser.roles.title
        axios.defaults.headers['Authorization'] = localStorage.getItem('token')
        this.openLoading();
        this.getCurrentYearAndMonth();
        if (currentUser.roles.title == "Program Officer") {
            axios
                .get(localStorage.getItem("BASE_PATH") + "/reports/dashboard-stats?id=" + currentUser.id)
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.dashboardData = response.data;
                    this.populateData();
                    this.populateCards();
                    this.provinceTraining();
                    this.animateCounts();
                })
            axios
                .get(localStorage.getItem("BASE_PATH") + "/reports/dashboard-graphs?id=" + currentUser.id)
                .then(response => {
                    this.graphData = response.data
                    this.pieChart();
                    this.filterThematicWiseCounts();
                    setTimeout(() => {
                        this.renderChart();
                    }, 1000);
                })

                .catch(error => {
                    console.error('Error fetching dashboard data:', error);
                });
        } else {
            axios
                .get(localStorage.getItem("BASE_PATH") + "/reports/dashboard-stats")
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.dashboardData = response.data;
                    this.populateData();
                    this.populateCards();
                    this.provinceTraining();
                    this.animateCounts();
                })
            axios
                .get(localStorage.getItem("BASE_PATH") + "/reports/dashboard-graphs")
                .then(response => {
                    this.graphData = response.data
                    this.pieChart();
                    this.filterThematicWiseCounts();
                    setTimeout(() => {
                        this.renderChart();
                    }, 1000);
                })
                .catch(error => {
                    console.error('Error fetching dashboard data:', error);
                });
        }

    },
    methods: {
        getCurrentYearAndMonth() {
            const currentDate = new Date();
            const currentYear = currentDate.getFullYear();
            // JavaScript months are zero-based, so we add 1 to get the correct month
            const currentMonthIndex = currentDate.getMonth();
            const currentMonthName = this.getMonthName(currentMonthIndex);

            this.currentYear = currentYear
            this.currentMonth = currentMonthName

        },
        getMonthName(monthIndex) {
            const monthNames = [
                "January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"
            ];
            return monthNames[monthIndex];
        },
        calculatePercentage(trainingCount) {
            const percentage = (trainingCount / this.countTotalTrainings()) * 100;
            return parseFloat(percentage.toFixed(2)) + '%';
        },
        countTotalTrainings() {
            const totalProvinceCounts = Object.values(this.dashboardData.provinceWiseCounts).reduce((total, count) => total + count, 0);
            return totalProvinceCounts
        },
        openLoading() {
            this.$vs.loading({
                type: "material"
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        },
        populateData() {
            this.data2 = [{
                    item: 1,
                    icon1: 'equalizer',
                    icon2: 'date_range',
                    category: 'Total Trainings Conducted',
                    value: this.dashboardData.totalTrainings,
                    currentCount: 0,
                    gradient: 'linear-gradient(60deg, #ec407a, #d81b60)',
                    dateLabel: `Till ${this.currentMonth +' '+this.currentYear}`,
                    iconColor: "#ec407a"
                },
                {
                    item: 2,
                    icon1: 'date_range',
                    icon2: 'date_range',
                    category: 'Trainings This Month',
                    value: this.dashboardData.trainingsThisMonth,
                    currentCount: 0,
                    gradient: 'linear-gradient(60deg, #66bb6a, #43a047)',
                    dateLabel: `${this.currentMonth +' '+this.currentYear}`,
                    iconColor: "#66bb6a"
                },
                {
                    item: 3,
                    icon1: 'assessment',
                    icon2: 'date_range',
                    category: 'Trainings This Year',
                    value: this.dashboardData.trainingsThisYear,
                    currentCount: 0,
                    gradient: 'linear-gradient(60deg, #ffa726, #fb8c00)',
                    dateLabel: `${this.currentYear}`,
                    iconColor: "#ffa726"
                },
                {
                    item: 4,
                    icon1: 'question_answer',
                    icon2: 'date_range',
                    category: 'Total Questions Created',
                    value: this.dashboardData.totalQuestions,
                    currentCount: 0,
                    gradient: 'linear-gradient(60deg, #26c6da, #00acc1)',
                    dateLabel: `Till ${this.currentMonth +' '+this.currentYear}`,
                    iconColor: "#26c6da"
                }

            ]
        },
        populateCards() {
            this.cards2 = [{
                    item: 1,
                    icon: 'assignment_ind',
                    category: 'Total Trainers Registered',
                    value: this.dashboardData.totalTrainers,
                    currentCount: 0,
                    gradient: 'linear-gradient(60deg, #9c27b0, #7b1fa2)'
                },
                {
                    item: 5,
                    icon: 'people',
                    category: 'Total Male Trainers',
                    value: this.dashboardData.totalMaleTrainers,
                    currentCount: 0,
                    gradient: 'linear-gradient(60deg, #7e57c2, #5e35b1)'
                },
                {
                    item: 6,
                    icon: 'people_outline',
                    category: 'Total Female Trainers',
                    value: this.dashboardData.totalFemaleTrainers,
                    currentCount: 0,
                    gradient: 'linear-gradient(60deg, #78909c, #546e7a)'
                },
                {
                    item: 2,
                    icon: 'assignment_ind',
                    category: 'Total Trainees Registered',
                    value: this.dashboardData.totalTrainees,
                    currentCount: 0,
                    gradient: 'linear-gradient(60deg, #ef5350, #e53935)'
                },
                {
                    item: 3,
                    icon: 'people',
                    category: 'Total Male Trainees',
                    value: this.dashboardData.totalMaleTrainees,
                    currentCount: 0,
                    gradient: 'linear-gradient(60deg, #29b6f6, #039be5)'
                },
                {
                    item: 4,
                    icon: 'people_outline',
                    category: 'Total Female Trainees',
                    value: this.dashboardData.totalFemaleTrainees,
                    currentCount: 0,
                    gradient: 'linear-gradient(60deg, #ffee58, #fbc02d)'
                },
                {
                    item: 7,
                    icon: 'check_circle_outline',
                    category: 'Total Trainings Completed',
                    value: this.dashboardData.totalCompletedTrainings,
                    currentCount: 0,
                    gradient: 'linear-gradient(60deg, #ff7043, #f4511e)'
                },
                {
                    item: 8,
                    icon: 'hourglass_empty',
                    category: 'Total Trainings in Progress',
                    value: this.dashboardData.totalInProgressTrainings,
                    currentCount: 0,
                    gradient: 'linear-gradient(60deg, #66cdaa, #2e8b57)'
                },
                {
                    item: 8,
                    icon: 'assignment_returned',
                    category: 'Total Upcoming Trainings',
                    value: this.dashboardData.totalUpcomingTrainings?? 0,
                    currentCount: 0,
                    gradient: 'linear-gradient(60deg, #9292b7, #a4a4ce)'
                }
            ]
        },
        animateCounts() {
            this.data2.forEach(card => {
                this.animateCount(card, card.value);
            });
            this.cards2.forEach(card => {
                this.animateCount(card, card.value);
            });

        },
        animateCount(card, value) {
            let count = 0;
            const step = Math.ceil(value / 30);
            const interval = setInterval(() => {
                count += step;
                if (count >= value) {
                    card.currentCount = value;
                    clearInterval(interval);
                } else {
                    card.currentCount = count;
                }
            }, 50);
        },
        provinceTraining() {

            this.provinceCounts = [
                {
                    provinceTitle: "Punjab",
                    trainingCount: this.dashboardData.provinceWiseCounts.Punjab ? this.dashboardData.provinceWiseCounts.Punjab : '0'
                },

                {
                    provinceTitle: "Balochistan",
                    trainingCount: this.dashboardData.provinceWiseCounts.Balochistan ? this.dashboardData.provinceWiseCounts.Balochistan : '0'
                },
                {
                    provinceTitle: "Sindh",
                    trainingCount: this.dashboardData.provinceWiseCounts.Sindh ? this.dashboardData.provinceWiseCounts.Sindh : '0'
                },
                {
                    provinceTitle: "Khyber Pakhtunkhwa",
                    trainingCount: this.dashboardData.provinceWiseCounts["Khyber Pakhtunkhwa"] ? this.dashboardData.provinceWiseCounts["Khyber Pakhtunkhwa"] : '0'
                }
            ]
        },
        pieChart() {
            Highcharts.chart("pie-chart", {
                chart: {
                    plotBackgroundColor: null,
                    plotBorderWidth: null,
                    plotShadow: false,
                    type: "pie"
                },
                title: {
                    text: "Provincial Distribution",
                },
                tooltip: {
                    pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>"
                },
                accessibility: {
                    point: {
                        valueSuffix: "%"
                    }
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: "pointer",
                        dataLabels: {
                            enabled: true,
                            format: "<b>{point.name}</b><br>{point.percentage:.1f} %",
                            distance: -35,
                            filter: {
                                property: "percentage",
                                operator: ">",
                                value: 4
                            }
                        },
                        innerSize: '50%'
                    }
                },
                series: [{
                    name: "Trainings",
                    data: [{
                            name: this.graphData.provinceGraphs[0].province,
                            y: parseFloat(this.graphData.provinceGraphs[0].percentage),
                            color: "#ec407a"
                        },
                        {
                            name: this.graphData.provinceGraphs[1].province,
                            y: parseFloat(this.graphData.provinceGraphs[1].percentage),
                            color: "#66bb6a"
                        },
                        {
                            name: this.graphData.provinceGraphs[2].province,
                            y: parseFloat(this.graphData.provinceGraphs[2].percentage),
                            color: "#ffa726"
                        },
                        {
                            name: this.graphData.provinceGraphs[3].province,
                            y: parseFloat(this.graphData.provinceGraphs[3].percentage),
                            color: "#26c6da"
                        },
                    ],

                }]
            });
        },
        filterThematicWiseCounts() {
            this.thematicWiseCounts = this.graphData.thematicWiseCounts.filter(item => {
                return item && item.training && !item.training.thematic_id.includes(',');
            }).filter(item => item !== null);
        },

        renderChart() {

            Highcharts.chart('thematic-chart', {
                chart: {
                    type: 'bar' // Changed from 'column' to 'bar'
                },
                title: {
                    align: 'left',
                    text: 'Thematic Training Counts'
                },

                accessibility: {
                    announceNewData: {
                        enabled: true
                    }
                },
                xAxis: {
                    type: 'category',
                    title: {
                        text: 'Thematic Area Names'
                    },
                    gridLineWidth: 0
                },
                yAxis: {
                    title: {
                        text: 'Training Count'
                    },
                    gridLineWidth: 0
                },
                legend: {
                    enabled: false
                },
                plotOptions: {
                    series: {
                        borderWidth: 0,
                        dataLabels: {
                            enabled: true,
                            format: '{point.y}'
                        }
                    }
                },
                tooltip: {
                    headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
                    pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b> trainings<br/>'
                },
                series: [{
                    name: 'Thematic Training Counts',
                    colorByPoint: true,
                    data: this.thematicWiseCounts.map(item => ({
                        name: item.thematic_name,
                        y: item.training.training_count
                    }))
                }]
            });
        }

    },

    components: {

    },

};
</script>

<style scoped>
.myNavbar {
    color: rgb(255, 255, 255);
}

.padding-15 {
    padding-right: 15px;
    padding-left: 15px;
}

.container-fluid {
    background-color: #eee;
}

.lyout-item {
    padding-right: 15px;
    padding-left: 15px;
}

.icon-large {
    font-size: 40px !important;
}

.icon-size {
    font-size: 24px !important;
}

.card:hover {
    transform: scale(1.03) translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.card-header-user {
    float: right;
    text-align: center;
    box-shadow: 0 12px 20px -10px rgba(76, 175, 80, .28), 0 4px 20px 0 rgba(0, 0, 0, .12), 0 7px 8px -5px rgba(76, 175, 80, .2);
    margin: -20px 15px 0;
    border-radius: 3px;
    padding: 20px;
}

.card-content-user {
    text-align: left;
    padding-top: 10px;
    padding-right: 20px;
    cursor: pointer;
}

.title-user {
    font-size: 20px;
    padding-left: 20px;
    font-weight: 900;
    color: #ec407a;
}

.card {
    display: inline-block;
    position: relative;
    width: 100%;
    margin: 25px 0;
    overflow: unset;
    -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, .14);
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, .14);
    border-radius: 3px;
    color: rgba(0, 0, 0, .87);
    background: #fff;
    transition: transform 0.9s ease, box-shadow 0.9s ease;
}

.card-header {
    float: left;
    text-align: center;
    box-shadow: 0 12px 20px -10px rgba(76, 175, 80, .28), 0 4px 20px 0 rgba(0, 0, 0, .12), 0 7px 8px -5px rgba(76, 175, 80, .2);
    margin: -20px 15px 0;
    border-radius: 3px;
    padding: 15px;
}

.card-content {
    text-align: right;
    padding-top: 10px;
    padding-right: 20px;
}

.category {
    color: #999;
}

.card-actions {
    margin: 0 20px 10px;
    padding: 10px 0 0;
    border-top: 1px solid #eee;
}

.alignment-left {
    justify-content: flex-start;
}

.status {
    line-height: 22px;
    color: #999;
    font-size: 12px;
}

.card-content2 {

    padding-top: 10px;
    padding-right: 20px;
}

.category2 {
    font-size: 20px;
    font-weight: 500;
    color: #3c4858;
}

.color-ff {
    color: #fff
}

.color-1 {
    background: linear-gradient(60deg, #ec407a, #d81b60);
}

.color-2 {
    background: linear-gradient(60deg, #66bb6a, #43a047);
}

.color-3 {
    background: linear-gradient(60deg, #ffa726, #fb8c00);
}

.color-4 {
    background: linear-gradient(60deg, #26c6da, #00acc1);
}

.table-cl {
    padding-left: 9px;
    font-size: 16px;
    padding-top: 10px
}

.table-ro {
    font-size: 20px;
}

#pie-chart {
    width: 98%;
    height: 350px;
}

#thematic-chart {
    height: 500px;

}
.mb5{
    margin-bottom:5px !important;
    margin-top: 1rem !important;
}
.bord-15 {
    border-radius: 15px;
}

@media (max-width: 768px) {}
</style>
